"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardRenderItemComponent_vue_1 = require("@/client/components/card/CardRenderItemComponent.vue");
const CardRenderSymbolComponent_vue_1 = require("@/client/components/card/CardRenderSymbolComponent.vue");
exports.default = vue_1.default.extend({
    name: 'CardProductionBoxComponent',
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_vue_1.default,
        CardRenderSymbolComponent: CardRenderSymbolComponent_vue_1.default,
    },
    methods: {
        getClasses() {
            const classes = ['card-production-box'];
            return classes.join(' ');
        },
    },
});
